module.exports = "bundles/1aa303c5f8288748eacf62c94b3aa377.png";


//////////////////
// WEBPACK FOOTER
// ./media/favicon_on.png
// module id = 145
// module chunks = 0